import { render, staticRenderFns } from "./csKp.vue?vue&type=template&id=1d770da0&scoped=true&"
import script from "./csKp.vue?vue&type=script&lang=js&"
export * from "./csKp.vue?vue&type=script&lang=js&"
import style0 from "./csKp.vue?vue&type=style&index=0&id=1d770da0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d770da0",
  null
  
)

export default component.exports